import { LoginCallback as AuthenticationLoginCallback } from 'module/authentication/components/login-callback';
import { LoginCallbackErrorPage } from 'module/authentication/components/login-callback/error';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { useNavigate } from '@rocketlane/rocket-router';
import { ROCKETLANE_EMAILS } from 'constant';
import { FC } from 'react';

interface Props {
  error: Error;
}

const CallbackError: FC<Props> = ({ error }) => {
  return (
    <LoginCallbackErrorPage
      error={error}
      supportEmail={ROCKETLANE_EMAILS.support}
      loginUrl="/login"
    />
  );
};

export const LoginCallback = () => {
  const navigate = useNavigate();

  return (
    <AuthenticationLoginCallback
      errorComponent={CallbackError}
      loadingElement={<PageLoading />}
      postLoginRedirectUrl={'/login'}
      onUserAuthenticatedInOkta={() => navigate('/')}
    />
  );
};
